import styled from "styled-components";

export const TicketFormContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  h2 {
    color: #373A3E;
    font-size: 14px;
    font-weight: 600;
  }

`;

export const SubjectInput = styled.input``;


export const TicketHeaderTitle = styled.div `
  padding: 16px 24px;
  border-bottom: 1px solid #D8DCDE;
`

export const TicketForm = styled.div `
  flex: 1;          
  min-height: 0;    
  overflow-y: auto;
  padding: 16px 24px;

  p{
    color: #373A3E;
    font-size: 14px;
    font-weight: 600;
    margin: 0.5rem 0;
  }

  select, input {
    padding: 10px 12px;
    background-color: transparent;
    border: 1px solid #A8B1B9;
    border-radius: 4px;
    width: 100%;
  }

  textarea {
    font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
    padding: 10px 12px;
    background-color: transparent;
    border: 1px solid #A8B1B9;
    border-radius: 4px;
    width: 100%;
    height: 100px;
    margin: 0.5rem 0;
  }
`

export const FooterTicket = styled.div`
  display: flex;
  padding: 16px 24px;
  align-items: center;
  gap: 8px;
  background-color: white;
  border-top: 1px solid #D8DCDE;
`

export const FailedTicketsAlert = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background-color: #FEF2F2;
  border-bottom: 1px solid #FECACA;
  
  p {
    color: #991B1B;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }

  button{
    padding: 12px 37px;
  }
`